import Schema from "AppReact/schema";

export default {
  linkCopied: Schema('boolean', "primitive", { defaultValue: false }),
  unitId: Schema('integer', "primitive-nullable", { defaultValue: null }),
  propertyId: Schema('integer', "primitive-nullable", { defaultValue: null }),
  linkText: Schema('string', 'primitive', { defaultValue: '' }),
  iconLeft: Schema({}, 'object', { defaultValue: null }),
  iconRight: Schema({}, 'object', { defaultValue: null }),
};
